import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#a)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#fff",
    "fill-opacity": ".9",
    "fill-rule": "evenodd",
    d: "m12.936 10.621-2.864 2.864H15a1 1 0 1 1 0 2H7.039l-.107.006-.453.017a3 3 0 0 1-2.232-.877l-2.61-2.61a3 3 0 0 1 0-4.243L8 1.414a2 2 0 0 1 2.829 0l4.243 4.243a2 2 0 0 1 0 2.828l-2.107 2.107-.014.015zM9.415 2.828l4.242 4.243-1.414 1.414-4.242-4.243zM6.586 5.657 3.051 9.192a1 1 0 0 0 0 1.415l2.61 2.61a1 1 0 0 0 .744.292l.453-.017a1 1 0 0 0 .67-.292l3.301-3.3z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#fff",
      d: "M0 0h16v16H0z"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }